(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-actions"] && !Shopify.designMode) return;
  try {
    if (!window.__cartDrawerToggleInit) {
    window.__cartDrawerToggleInit = true;

    document.addEventListener('click', function (event) {
      const toggle = event.target.closest('.cart-drawer__toggle-items');
      if (!toggle) return;

      const dialog = toggle.closest('.cart-drawer__dialog');
      if (!dialog) return;

      const isExpanded = toggle.getAttribute('data-expanded') === 'true';

      toggle.setAttribute('data-expanded', String(!isExpanded));
      toggle.setAttribute('aria-expanded', String(!isExpanded));
      dialog.classList.toggle('cart-drawer__dialog--expanded', !isExpanded);
    });

    document.addEventListener('click', function (event) {
      if (event.target.closest('[on\\:click="cart-drawer-component/close"]')) {
        document.querySelectorAll('.cart-drawer__toggle-items').forEach((toggle) => {
          toggle.setAttribute('data-expanded', 'false');
          toggle.setAttribute('aria-expanded', 'false');
        });
        document.querySelectorAll('.cart-drawer__dialog--expanded').forEach((dialog) => {
          dialog.classList.remove('cart-drawer__dialog--expanded');
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
